//angular imports
import {
  ChangeDetectionStrategy,
  Component,
  inject,
  resource,
} from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { toSignal } from "@angular/core/rxjs-interop";
import { map, Subject, takeUntil } from "rxjs";

//local imports
import { CatalogStateService, DocumentModel } from "@app/catalog";
import { CatalogCommonConstants } from "@app/catalog-common";
import { Messenger } from "@app/shared";
import { NavigationService } from "@app/core";

@Component({
  selector: 'department-property',
  standalone: false,
  templateUrl: './department-property.component.html',
  styleUrl: './department-property.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DepartmentPropertyComponent {
  private route = inject(ActivatedRoute);
  private catalogStateService = inject(CatalogStateService);
  private navigationService = inject(NavigationService);
  private messenger = inject(Messenger);

  private readonly destroying$ = new Subject<void>();


  public departmentId = toSignal(
     this.route.paramMap.pipe(map(params => params.get(CatalogCommonConstants.ROUTE_PARAMS.ID)))
  );

  private programId = toSignal(
    this.route.queryParamMap.pipe(map(params => params.get(CatalogCommonConstants.ROUTE_PARAMS.PROGRAM_ID)))
  );

  private projectId = toSignal(
    this.route.queryParamMap.pipe(map(params => params.get(CatalogCommonConstants.ROUTE_PARAMS.PROJECT_ID)))
  );


  public propertyResource = resource({
    request: () => ({
      id: this.departmentId(),
      programId: this.programId(),
      projectId: this.projectId(),
    }),
    loader: async ({ request }) => {
      const property = await this.catalogStateService.getDepartmentProperty(
        request.id,
        request.programId,
        request.projectId,
      );

      if (property.documents) {
        const filteredDocuments = property.documents().filter(
          (doc: DocumentModel) => !doc.superseded()
        );
        property.documents.set(filteredDocuments);
      }
          
      return property;
    }
  });

  public ngOnInit(): void {
    this.catalogStateService.initialize(this.route);

    this.route.queryParamMap.pipe(
      takeUntil(this.destroying$)
    ).subscribe((params) => {
      const departmentId = params.get(CatalogCommonConstants.ROUTE_PARAMS.DEPARTMENT_ID);

      if (!departmentId) {
        this.navigationService.back();
      }
    });
    
  }

  ngOnDestroy(): void {
    this.messenger.unsubscribeByOwner(this);
    this.destroying$.next(undefined);
    this.destroying$.complete();
  }

}
